import { useContext, useEffect, useCallback, useRef, useState } from 'react';
import './dxPopupLogin.scss';
import { Button } from 'devextreme-react';
import { NumberBox } from 'devextreme-react/number-box';
import { TextBox } from 'devextreme-react/text-box';
import { CheckBox } from 'devextreme-react/check-box';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { AccountContext } from '../context/account-context'
import { ErrorContext } from '../context/error-context'
import Validator, { RequiredRule } from 'devextreme-react/validator';
import ValidationGroup from 'devextreme-react/validation-group';
import Logo from '../img/ControlPlusLogo.png';
import { getAccount, getToken } from '../common/api-requests';

export default function Login() {

    const [account, setAccount] = useContext(AccountContext);
    const [error, setError] = useContext(ErrorContext);
    const [value, setValue] = useState('');

    const nmbPhone = useRef(null);
    const txtPassword = useRef(null);
    const chkIsRemember = useRef(null);

    //const [options, setOptions] = useState({ currency: userContext.currency,
    //});

    const handleTextBoxPhoneOnKeyDown = useCallback((e) => {

        if (e.event.keyCode < 48 || e.event.keyCode > 57) {
            e.event.preventDefault();
        }

    });

    const handleTextBoxPhoneChange = (e) => {
            const numericValue = e.event.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
            setValue(numericValue);
    };

   
    const handleSubmitClick = useCallback((e) => {

        let isRemember = chkIsRemember.current.instance.option("value");
        let phone = nmbPhone.current.instance.option("value");
        let password = txtPassword.current.instance.option("value");

        const result = e.validationGroup.validate();

        if (!result.isValid)
            return;

        getToken(phone, password).then((response) => {

            setAccount({ id: response.id, isRemember: isRemember, token: response.token, phone: phone, password: password });
        })
            .catch((errorInner) => {
                setError("(" + errorInner.status + ")" + " " + errorInner.text);
            });

    });


    //const showPopup = useCallback(() => {
    //    setPopupVisible(true);
    //}, [setPopupVisible]);

    return (

        <Popup
            width={500}
            height="auto"
            visible={!account}
            hideOnOutsideClick={false}
            showCloseButton={false}
            showTitle={false}
            dragEnabled={false}
        >
            <div className="content">
                <div className="popupLoginContainer">
                    <img src={Logo} alt="logo" width="404" />

                    <ValidationGroup>

                        <div className="phoneContainer">
                            <div style={{ color: "#ddd", marginRight: "6px" }}>+380</div>

                          {/*  <NumericInput></NumericInput>*/}

                            <TextBox className="nmbPhone"
                                labelMode="floating"
                                label="Телефон"
                                width={404}
                                height="100%"
                                ref={nmbPhone}
                                mode="tel"
                                value={value}
                                onChange={handleTextBoxPhoneChange}
                            >

                                <Validator >
                                    <RequiredRule />
                                </Validator>
                            </TextBox>
                        </div>


                        <div className="passwordContainer">
                            <TextBox
                                labelMode="floating"
                                max={999999999}
                                label="Пароль"
                                width="100%"
                                height="100%"
                                mode="password"
                                ref={txtPassword}
                                name="password"
                                autoComplete="on"
                            >

                                <Validator>
                                    <RequiredRule />
                                </Validator>

                            </TextBox>
                        </div>

                        <div className="passwordContainer">
                            <CheckBox
                                text="Запам'ятати мене"
                                ref={chkIsRemember}
                            ></CheckBox>

                            <a className="hlForgetPassword">Забули пароль?</a>
                        </div>

                        <Button className="btnSubmit"
                            width={404}
                            text="Увійти"
                            onClick={handleSubmitClick}
                        />

                    </ValidationGroup>

                </div>

            </div>

        </Popup>

    );
}

